__turbopack_context__.v({
  "alertMessage": "order-lookup-module-scss-module__4ziCfW__alertMessage",
  "fulfilledByMEC": "order-lookup-module-scss-module__4ziCfW__fulfilledByMEC",
  "hr": "order-lookup-module-scss-module__4ziCfW__hr",
  "instructionsContainer": "order-lookup-module-scss-module__4ziCfW__instructionsContainer",
  "instructionsList": "order-lookup-module-scss-module__4ziCfW__instructionsList",
  "pageContainer": "order-lookup-module-scss-module__4ziCfW__pageContainer",
});
